import { createSelector } from '@ngrx/store';

import { BlockState } from '../state/block.state';
import { selectSystemState } from './system.selectors';
import { selectBlockState } from './block.selectors';

export const selectAlertsListComponent = createSelector(
  selectBlockState,
  (state: BlockState) => state.blockList.AlertsListComponent
);

export const selectSystemDailyAlertsBySelectedSystem = (instanceId: string) => createSelector(
  selectSystemState,
  selectAlertsListComponent,
  (systemState, alertsListComponent) => {
    const selectedSystem = systemState.selectedSystemUid;
    if (!selectedSystem) {
      return null;
    }

    const instanceBlock = alertsListComponent[instanceId];
    if (!instanceBlock) {
      return null;
    }

    const systemBlock = instanceBlock[selectedSystem];
    if (!systemBlock) {
      return null;
    }

    return {
      alerts: systemBlock.alerts,
      allTimestampsBySerial: systemBlock.allTimestampsBySerial,
    };
  }
);

export const selectSystemDailyAlertsStatusBySelectedSystem = (instanceId: string) => createSelector(
  selectSystemState,
  selectAlertsListComponent,
  (systemState, alertsListComponent) => {
    const selectedSystem = systemState.selectedSystemUid;
    if (!selectedSystem) {
      return null;
    }

    const instanceBlock = alertsListComponent[instanceId];
    if (!instanceBlock) {
      return null;
    }

    return instanceBlock[selectedSystem]?.state;
  }
);